module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_32.f1d3ad40.mp3";